<template>
  <div class="checkList_box_wrap">
    <vxe-toolbar
      id="toolbarId_ca8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('checkList_shipenment_search_btn')"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button @click="batchInputDialogVisible = true"
          >多运单查询</el-button
        >
        <el-button
          v-if="getLimit('checkList_shipenment_export_btn')"
          @click="funcExport()"
        >
          全部导出
        </el-button>
        <el-button @click="columnSettingVisible = true">列设置</el-button>
      </template>
    </vxe-toolbar>
    <!-- <div class="checkList_total">
      合计实付总金额:
      <span style="color:red;">{{ shipmentActualFreightTotal || "--" }}元</span>
    </div> -->
    <!-- table表格
      @sort-change="sortList"
      :footer-method="footerMethod"
      :loading="loading"
    -->
    <vxe-table
      v-if="showTable"
      ref="xTable"
      :data="tableData"
      :loading="loading"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="90%"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :footer-method="footerMethod"
    >
      <vxe-table-column
        v-for="(col, index) in columns"
        v-if="col.visible && (col.isAdmin ? isAdmin : true)"
        :key="index"
      >
        <vxe-table-column
          :field="col.value"
          :title="col.name"
          :min-width="col.minWidth || 200"
          :sortable="
            col.value === 'gmtCreated' ||
              col.value === 'lastLoadingTime' ||
              col.value === 'lastUnloadingTime' ||
              col.value === 'gmtModified'
          "
        >
          <template #default="scope">
            <div class="oeder_num_box">
              <el-tooltip
                class="item"
                effect="dark"
                :content="String(formatterSwitch(scope))"
                placement="top-start"
              >
                <span
                  class="copy_text_cursor"
                  @click="copyText(formatterSwitch(scope))"
                  >{{ formatterSwitch(scope) }}</span
                ></el-tooltip
              >
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <template
            v-if="
              col.value === 'groupName' ||
                col.value === 'orderCode' ||
                col.value === 'driverName' ||
                col.value === 'driverPhone' ||
                col.value === 'vehicleLicense' ||
                col.value === 'coalTypeName' ||
                col.value === 'loadPlace' ||
                col.value === 'unloadPlace' ||
                col.value === 'createdByName' ||
                col.value === 'dfName' ||
                col.value === 'salesmanName' ||
                col.value === 'projectName'
            "
          >
            <el-input
              v-model="listQuery[col.value]"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'taxPoint'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPointStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPointEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'channelExecRate'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.channelExecRateStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.channelExecRateEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'weight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.weightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.weightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <!-- 运单状态 -->
          <template v-if="col.value === 'status'">
            <el-select
              v-model="listQuery.status"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <!-- 开票状态 invoiceStatus -->
          <template v-if="col.value === 'invoiceStatus'">
            <el-select
              v-model="listQuery.invoiceStatus"
              clearable
              placeholder="请选择"
              @clear="() => (listQuery.invoiceStatus = null)"
            >
              <el-option
                v-for="item in invoiceStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'invoiceIssuedTime'">
            <el-date-picker
              v-model="listQuery.invoiceIssuedTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'invoiceIssuedTime')"
            />
          </template>
          <template v-if="col.value === 'settleTime'">
            <el-date-picker
              v-model="listQuery.settleTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'settleTime')"
            />
          </template>
          <template v-if="col.value === 'payAmount'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.payAmountStart"
                  style="padding-right:0px!important;"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.payAmountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'yuPayTime'">
            <el-date-picker
              v-model="listQuery.yuPayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'yuPayTime')"
            />
          </template>
          <template v-if="col.value === 'shipperDeliveryFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeStart"
                  style="padding-right:0px!important;"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'daPayTime'">
            <el-date-picker
              v-model="listQuery.daPayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'daPayTime')"
            />
          </template>

          <template v-if="col.value === 'shipmentActualCash'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualCashStart"
                  style="padding-right:0px!important;"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualCashEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <template v-if="col.value === 'huPayTime'">
            <el-date-picker
              v-model="listQuery.huPayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'huPayTime')"
            />
          </template>

          <template v-if="col.value === 'gmtCreated'">
            <el-date-picker
              v-model="listQuery.gmtCreated"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
          <template v-if="col.value === 'fillTime'">
            <el-date-picker
              v-model="listQuery.fillTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'fillTime')"
            />
          </template>
          <template v-if="col.value === 'signTime'">
            <el-date-picker
              v-model="listQuery.signTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'signTime')"
            />
          </template>
          <template v-if="col.value === 'orderTime'">
            <el-date-picker
              v-model="listQuery.orderTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'orderTime')"
            />
          </template>
        </template>
      </vxe-table-column>

      <template v-if="false">
        <vxe-table-column>
          <vxe-table-column field="groupName" title="承运主体" min-width="300">
            <template #default="{row}">
              {{ row.groupName ? row.groupName : "/" }}
            </template>
          </vxe-table-column>
          <template v-slot:header>
            <el-input
              v-model="listQuery.groupName"
              placeholder="请输入承运主体"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="orderCode"
            title="运单单号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.orderCode"
              placeholder="请输入运单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="status"
            title="运单状态"
            :formatter="formatterStatus"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.status"
              clearable
              placeholder="请选择运单状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="invoiceStatus"
            align="center"
            title="开票状态"
            width="180"
          />

          <template v-slot:header>
            <el-select
              v-model="listQuery.invoiceStatus"
              placeholder="请选择开票状态"
              clearable
              @clear="clearInvoiceStatus"
            >
              <el-option
                v-for="item in invoiceStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <!-- <template #default="{ row }">{{ row }}</template> -->
        </vxe-table-column>

        <!-- 开票时间 -->
        <vxe-table-column>
          <vxe-table-column
            align="center"
            field="invoiceIssuedTime"
            title="开票时间"
            width="300"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.invoiceIssuedTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'invoiceIssuedTime')"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="shipmentDeliveryFeePractical"
            title="运费总额（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="serviceFee"
            title="总服务费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.serviceFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.serviceFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="deliveryFeePractical"
            title="实际承运人应净得运费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="driverName"
            title="实际承运人姓名"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverName"
              placeholder="请输入实际承运人姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="实际承运人电话"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="请输入实际承运人电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="vehicleLicense"
            title="车牌号"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.vehicleLicense"
              placeholder="请输入车牌号"
              clearable
            />
          </template>
        </vxe-table-column>

        <!-- 预付 -->
        <vxe-table-column>
          <vxe-table-column
            field="payAmount"
            title="预付运费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-input
            v-model="listQuery.shipmentActualFreight"
            placeholder="请输入金额"
            clearable
          /> -->
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.payAmountStart"
                  style="padding-right:0px!important;"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.payAmountEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="yuPayTime"
            title="预付支付时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.yuPayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'yuPayTime')"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="shipperDeliveryFee"
            title="到付运费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-input
            v-model="listQuery.shipmentActualFreight"
            placeholder="请输入金额"
            clearable
          /> -->
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeStart"
                  style="padding-right:0px!important;"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="daPayTime"
            title="到付支付时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.daPayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'daPayTime')"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="shipmentActualCash"
            title="回单付款费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-input
            v-model="listQuery.shipmentActualFreight"
            placeholder="请输入金额"
            clearable
          /> -->
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualCashStart"
                  style="padding-right:0px!important;"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualCashEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="huPayTime"
            title="回单付支付时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.huPayTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'huPayTime')"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="货物名称"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="请输入货物名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="货物数量(吨)"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="请输入货物数量"
              clearable
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            title="接单时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreated"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="fillTime"
            title="装车时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.fillTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'fillTime')"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column>
          <vxe-table-column
            field="signTime"
            title="卸车时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.signTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="value => changeDate(value, 'signTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            align="center"
            field="loadPlace"
            title="装货地址"
            width="200"
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.loadPlace"
              placeholder="请输入地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            align="center"
            field="unloadPlace"
            title="卸货地址"
            width="200"
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.unloadPlace"
              placeholder="请输入地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="createdByName"
            title="托运人"
            min-width="250"
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.createdByName"
              placeholder="请输入托运人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="dfName"
            title="经办人"
            min-width="120"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.dfName"
              placeholder="请输入经办人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            show-header-overflow
            show-overflow
            title="下单时间"
            min-width="420"
            sortable
            :resizable="false"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.fromDate"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="optionsPicker"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="—"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <!-- 分页 -->
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- etc发票详情弹窗 -->
    <vxe-modal
      v-model="showDetail"
      title="ect发票详情"
      width="1070"
      height="600"
      resize
    >
      <checkDetail />
    </vxe-modal>
    <el-dialog
      title="列设置"
      :visible.sync="columnSettingVisible"
      width="480px"
      custom-class="column-setting-dialog"
    >
      <ColumnDrag :columns="columns" @update="applyColumnSettings" />
    </el-dialog>
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      />
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import BatchWaybill from "@/components/BatchWaybill";
import ColumnDrag from "@/components/ColumnDrag.vue";
import { getLimit } from "@/utils/getLimit.js";
import checkDetail from "./components/checkDetail.vue";
import { settlementlistshipper, settlementlistExport } from "@/api/category";

export default {
  components: {
    BatchWaybill,
    checkDetail,
    ColumnDrag
  },
  data() {
    return {
      isAdmin: false,
      showTable: true,
      batchInputDialogVisible: false,
      columns: [
        {
          name: "承运主体",
          value: "groupName",
          visible: true,
          minWidth: 300
        },
        {
          name: "项目名称",
          value: "projectName",
          visible: true,
          minWidth: 300
        },
        {
          name: "运单单号",
          value: "orderCode",
          visible: true,
          minWidth: 200
        },
        {
          name: "支付状态",
          value: "status",
          visible: true,
          minWidth: 130
        },
        {
          name: "开票状态",
          value: "invoiceStatus",
          visible: true,
          minWidth: 180
        },
        {
          name: "开票时间",
          value: "invoiceIssuedTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "运费总额（元）",
          value: "shipmentDeliveryFeePractical",
          visible: true,
          minWidth: 190
        },
        {
          name: "总服务费（元）",
          value: "serviceFee",
          visible: true,
          minWidth: 190
        },
        {
          name: "服务费率", //new=========================================================
          value: "taxPoint",
          visible: true,
          minWidth: 190,
          isAdmin: true
        },
        {
          name: "实际承运人应净得运费（元）",
          value: "deliveryFeePractical",
          visible: true,
          minWidth: 190
        },
        {
          name: "实际承运人姓名",
          value: "driverName",
          visible: true,
          minWidth: 160
        },
        {
          name: "实际承运人电话",
          value: "driverPhone",
          visible: true,
          minWidth: 160
        },
        {
          name: "车牌号",
          value: "vehicleLicense",
          visible: true,
          minWidth: 160
        },
        {
          name: "预付运费（元）",
          value: "payAmount",
          visible: true,
          minWidth: 220
        },
        {
          name: "预付支付时间",
          value: "yuPayTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "到付运费（元）",
          value: "shipperDeliveryFee",
          visible: true,
          minWidth: 220
        },
        {
          name: "到付支付时间",
          value: "daPayTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "回单付款费（元）",
          value: "shipmentActualCash",
          visible: true,
          minWidth: 220
        },
        {
          name: "回单付支付时间",
          value: "huPayTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "货物名称",
          value: "coalTypeName",
          visible: true,
          minWidth: 160
        },
        {
          name: "货物数量(吨)",
          value: "weight",
          visible: true,
          minWidth: 220
        },
        {
          name: "接单时间",
          value: "gmtCreated",
          visible: true,
          minWidth: 300
        },
        {
          name: "装车时间",
          value: "fillTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "卸车时间",
          value: "signTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "装货地址",
          value: "loadPlace",
          visible: true,
          minWidth: 300
        },
        {
          name: "卸货地址",
          value: "unloadPlace",
          visible: true,
          minWidth: 300
        },
        {
          name: "托运人",
          value: "createdByName",
          visible: true,
          minWidth: 250
        },
        {
          name: "经办人",
          value: "dfName",
          visible: true,
          minWidth: 120
        },
        {
          name: "下单时间",
          value: "orderTime",
          visible: true,
          minWidth: 300
        },
        {
          name: "审核时间", //审核时间
          value: "settleTime",
          visible: true,
          minWidth: 280,
          isAdmin: true
        },
        {
          name: "平台服务经理", //审核时间
          value: "salesmanName",
          visible: true,
          minWidth: 190,
          isAdmin: true
        },
        {
          name: "渠道执行费率",
          value: "channelExecRate",
          visible: true,
          minWidth: 220,
          isAdmin: true
        }
      ],
      columnSettingVisible: false,
      statusOptions: [
        { value: "1", label: "已接单" },
        { value: "2", label: "已装货" },
        { value: "3", label: "已卸货" },
        { value: "4", label: "已核算" },
        { value: "5", label: "部分支付" },
        { value: "6", label: "已打款" }
      ],
      feeStatus: [
        { label: "待打款", value: "0" },
        { label: "部分打款", value: "1" },
        { label: "已打款", value: "2" },
        { label: "支付失败", value: "3" }
      ],
      invoiceStatusList: [
        { label: "申请开票", value: "0" },
        { label: "已开票", value: "1" },
        { label: "已取消", value: "2" },
        { label: "确认收票", value: "3" },
        { label: "开票中", value: "4" },
        { label: "开票失败", value: "5" },
        { label: "红冲中", value: "6" },
        { label: "已红冲", value: "7" },
        { label: "红冲待确认", value: "8" }
      ],
      shipmentActualFreightTotal: null,
      exportObj: {
        exportUrl: `/ntocc-tms-api/orderDetail/settlementlistshipperExport`, //导出接口
        name: "运费结算清单",
        methods: true
      },
      checkList_export: false,
      checkList_search_btn: false,
      checkListTotal_export: false,
      listQuery: {
        groupName: "",
        orderCode: "",
        createdByName: "",
        shipmentDeliveryFeePracticalStart: "",
        shipmentDeliveryFeePracticalEnd: "",
        serviceFeeStart: "",
        serviceFeeEnd: "",
        deliveryFeePracticalStart: "",
        deliveryFeePracticalEnd: "",
        shipmentActualFreightStart: "",
        shipmentActualFreightEnd: "",
        actualServiceFeeStart: "",
        actualServiceFeeEnd: "",
        driverActualFreightStart: "",
        driverActualFreightEnd: "",
        noPayShipmentFeeStart: "",
        noPayShipmentFeeEnd: "",
        noGetServiceFeeStart: "",
        noGetServiceFeeEnd: "",
        noGetDriverFeeStart: "",
        noGetDriverFeeEnd: "",
        // invoiceStatus: null,
        invoiceIssuedTimeStart: null,
        invoiceIssuedTimeEnd: null,
        codeETC: null,
        invoiceNumber: null,
        coalTypeName: null,
        weight: null,
        loadPlace: null,
        unloadPlace: null,
        channelExecRateStart: null,
        channelExecRateEnd: null,
        total: 0,
        payStatus: null,
        invoiceStatus: null
        //
        // orderCode: "",
        // createdByName: "",
        // payStatus: null,
        // payTime: "",
        // // shipmentActualFreight: "",
        // // taxPayFee: "",
        // // driverActualFreight: "",
        // etcType: "",
        // coalTypeName: "",
        // // weight: null,
        // weightStart: "",
        // weightEnd: "",
        // driverActualFreightStart: "",
        // driverActualFreightEnd: "",
        // taxPayFeeStart: "",
        // invoiceStatus: null,
        // taxPayFeeEnd: "",
        // shipmentActualFreightStart: "",
        // shipmentActualFreightEnd: "",
        // loadPlace: "",
        // unloadPlace: ""
      },
      paymentStatusOptions: [
        { value: "0", label: "处理中" },
        { value: "1", label: "已支付" },
        { value: "2", label: "支付失败" },
        { value: "", label: "未支付" } //TODO:"99"处理不显示清除icon的问题
      ],
      preOptions: [
        { value: 0, label: "到付运费" },
        { value: 1, label: "预付运费" },
        { value: 2, label: "回单运费" }
      ],
      invoiceStatusOptions: [
        { value: "0", label: "申请开票" },
        { value: "1", label: "已开票" },
        { value: "2", label: "已取消" },
        { value: "", label: "未开票" } //TODO:"99"处理不显示清除icon的问题
      ],
      etcInvoiceStatusOptions: [
        { value: "未开票", label: "未开票" },
        { value: "已开票", label: "已开票" }
      ],

      tableData: [],
      showDetail: false,
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.checkList_export = getLimit("checkList_export");
    this.checkList_search_btn = getLimit("checkList_search_btn");
    this.checkListTotal_export = getLimit("checkListTotal_export");
    this.findList();
    let shipmentColumn = localStorage.getItem("shipmentColumn") || "";
    this.columns = JSON.parse(shipmentColumn);
    // 检查是否包含"服务费率"对象，如果没有则添加
    if (this.columns && Array.isArray(this.columns)) {
      const hasTaxPoint = this.columns.some(col => col.value === "taxPoint");
      if (!hasTaxPoint) {
        const serviceFeeIndex = this.columns.findIndex(
          col => col.value === "serviceFee"
        );
        if (serviceFeeIndex !== -1) {
          this.columns.splice(serviceFeeIndex + 1, 0, {
            name: "服务费率",
            value: "taxPoint",
            visible: true,
            minWidth: 190,
            isAdmin: true
          });
          this.columns.push(
            {
              name: "审核时间",
              value: "settleTime",
              visible: true,
              minWidth: 190,
              isAdmin: true
            },
            {
              name: "平台服务经理",
              value: "salesmanName",
              visible: true,
              minWidth: 190,
              isAdmin: true
            }
          );
        }
        // 兼容旧缓存列：补「渠道执行费率」列（放在「平台服务经理」后面），并保证宽度能容纳筛选框
        const channelRateIndex = this.columns.findIndex(
          col => col.value === "channelExecRate"
        );
        if (channelRateIndex === -1) {
          const channelRateCol = {
            name: "渠道执行费率",
            value: "channelExecRate",
            visible: true,
            minWidth: 220,
            isAdmin: true
          };
          const salesmanIndex = this.columns.findIndex(
            col => col.value === "salesmanName"
          );
          if (salesmanIndex !== -1) {
            this.columns.splice(salesmanIndex + 1, 0, channelRateCol);
          } else {
            this.columns.push(channelRateCol);
          }
        } else if (
          !this.columns[channelRateIndex].minWidth ||
          this.columns[channelRateIndex].minWidth < 220
        ) {
          this.columns[channelRateIndex].minWidth = 220;
        }
      }
      // this.columns中 name: "承运主体"后面的元素如果不是 name: "项目名称"，则加上
      const networkCarrierIndex = this.columns.findIndex(
        col => col.name === "承运主体"
      );
      if (networkCarrierIndex !== -1) {
        const nextCol = this.columns[networkCarrierIndex + 1];
        if (!nextCol || nextCol.name !== "项目名称") {
          this.columns.splice(networkCarrierIndex + 1, 0, {
            name: "项目名称",
            value: "projectName",
            visible: true,
            minWidth: 300
          });
        }
      }
    }
  },
  mounted() {},
  methods: {
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    },
    formatterSwitch(scope) {
      // console.log("格式处理=========", cell);
      // 实际承运人净得判断 未签收：deliveryFeeDeserved  已签收：deliveryFeePractical
      let valueCell = scope.row[scope.column.property];
      if (scope.column.property === "status") {
        const item = this.statusOptions.find(item => item.value === valueCell);
        return item ? item.label : "";
      }
      if (scope.column.property === "channelExecRate") {
        return valueCell === null || valueCell === undefined || valueCell === ""
          ? "--"
          : `${Number(valueCell).toFixed(1)}%`;
      }
      return valueCell;
    },
    applyColumnSettings(payload) {
      console.log("更新返回===========", payload);
      this.columns = payload.columns;
      localStorage.setItem("shipmentColumn", JSON.stringify(payload.columns));
      this.columnSettingVisible = false;
      this.showTable = false;
      this.$nextTick(() => {
        this.showTable = true;
      });
      this.$forceUpdate();
    },
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterInvoiceStatus({ cellValue }) {
      const item = this.invoiceStatusList.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterServicePAy(row) {
      console.log(row.row.isPayAdvance);
      if (row.row.isPayAdvance == 0) {
        return row.row.taxPayFee;
      } else if (row.row.isPayAdvance == 1) {
        return "--";
      } else if (row.row.isPayAdvance == 2) {
        return row.row.returnTaxFee;
      }
    },

    formatterPayType(row) {
      console.log("formatterPayType================", row);
      switch (row.row.isPayAdvance) {
        case 0:
          return "到付运费";
        case 1:
          return "预付运费";
        case 2:
          return "回单运费";
      }
    },
    async getSettlementlistExport() {
      let res = await settlementlistExport(this.listQuery);
      console.log("getSettlementlistExport===", res);
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "shipmentDeliveryFeePractical") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "serviceFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "deliveryFeePractical") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "payAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipmentActualCash") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "weight") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    clearPayStatus() {
      this.listQuery.payStatus = null;
    },
    clearInvoiceStatus() {
      this.listQuery.invoiceStatus = null;
    },
    getInvoiceStatus(state) {
      switch (state) {
        case "0":
          return "申请开票";
        case "1":
          return "已开票";
        case "2":
          return "已取消";
        case "3":
          return "确认收票";
        case "4":
          return "开票中";
        case "5":
          return "开票失败";
        case "6":
          return "红冲中";
        case "7":
          return "已红冲";
        case "8":
          return "红冲待确认";
        default:
          return "未开票";
      }
    },
    getEtcType(type) {
      switch (type) {
        case "0":
          return "未推送";
        case "1":
          return "已推送";
        case "2":
          return "推送完成";
        case "5":
          return "分单已推送";
        default:
          return "--";
      }
    },
    getPayState(state) {
      switch (state) {
        case "0":
          return "处理中";
        case "1":
          return "已支付";
        case "2":
          return "支付失败";
        default:
          return "未支付";
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        // let data = { ...this.listQuery, weight: +this.listQuery.weight };
        // if (this.listQuery.payTime) {
        //   data.payTimeStart = this.listQuery.payTime[0];
        //   data.payTimeEnd = this.listQuery.payTime[1];
        //   delete data.payTime;
        // }
        // if (this.listQuery.invoiceIssuedTime) {
        //   data.invoiceIssuedTimeStart = this.listQuery.invoiceIssuedTime[0];
        //   data.invoiceIssuedTimeEnd = this.listQuery.invoiceIssuedTime[1];
        //   delete data.invoiceIssuedTime;
        // }
        // if (data.payStatus === "99") {
        //   data.payStatus = "";
        // }

        let data = {
          ...this.listQuery
        };
        if (data.invoiceStatus === "99") {
          data.invoiceStatus = "";
        }
        settlementlistshipper(data).then(response => {
          this.loading = false;

          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;

          // this.shipmentActualFreightTotal =
          //   response.data.sumObject.shipmentActualFreight;
          this.tableData.forEach(item => {
            item.invoiceStatus = this.getInvoiceStatus(item.invoiceStatus);
            item.EtcYDcode = Array.isArray(item.etcInvoiceList)
              ? item.etcInvoiceList[0].code
              : "/";
            // item.invoiceCodeExcel = Array.isArray(item.etcInvoiceList)
            //   ? item.etcInvoiceList.map(item => item.invoiceCode).join(";")
            //   : "/";
            // console.log("item.invoiceCodeExcel", item.invoiceCodeExcel);
            // item.invoiceNumExcel = Array.isArray(item.etcInvoiceList)
            //   ? item.etcInvoiceList.map(item => item.invoiceNum).join(";\n")
            //   : "/";
            console.log("item.invoiceNumExcel", item.invoiceNumExcel);
          });

          this.sumObject = response.data.sumObject;
          resolve();
        });
      });
    },
    handleDetail(row) {
      // this.$refs.checkDetail.getData(row);
    },
    handleEtcInvoiceCount(row) {
      // 处理ETC发票数量点击事件
      this.showDetail = true;
      console.log("ETC发票数量点击:", row);
    }
  }
};
</script>
<style lang="scss">
.copy_text_cursor {
  cursor: pointer;
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    font-weight: bold;
  }
}
.checkList_box_wrap {
  height: calc(100vh - 160px);
  padding: 15px;
  .vxe-pager.is--loading:after {
    background-color: transparent;
  }
  position: relative;
}
</style>
<style scoped>
.checkList_total {
  position: absolute;
  right: 124px;
  top: 25px;
  font-weight: bold;
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
.etc-invoice-count {
  color: #409eff;
  cursor: pointer;
}
.pay_success {
  color: green;
  font-weight: bold;
}
</style>
